import MasterCrud from "@/components/MasterCrud";
import { Building2 } from "lucide-react";

export default function HRMSDepartments() {
  return (
    <MasterCrud
      endpoint="/departments"
      slug="hr-dept"
      title="Department Master"
      subtitle="HRMS · Departments"
      icon={Building2}
      importKey="departments"
      fields={[
        ["name", "Name"],
        ["status", "Status", "select-static", ["Active", "Inactive"]],
      ]}
    />
  );
}
